import type { GetFilterFieldsQuery } from 'src/gql/tal/generated';
import type {
  Driver,
  DriverList,
  DriverOption,
} from './components/QueryFilter';

const driversMap: Map<string, string> = new Map([
  ['industries', 'Industry'],
  ['genders', 'Gender'],
  ['senioritys', 'Seniority'],
  ['generations', 'Generation'],
  ['locations', 'Location'],
  ['workTypes', 'Work type'],
]);

const getDriverListFrom = (queryFilter: GetFilterFieldsQuery): DriverList => {
  const entries = Object.entries(queryFilter);
  const drivers = entries.map(
    ([key, values]) =>
      ({
        name: driversMap.get(key),
        options: values.map((value: DriverOption) => ({ name: value.name })),
      } as Driver),
  );

  return {
    drivers,
  };
};

export const dataLabHelper = {
  getDriverListFrom,
};
